"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");

var UserMessageCode_1 = require("./UserMessageCode");

var UserMessageFlag_1 = require("./UserMessageFlag");

var UserMessageSeverity_1 = require("./UserMessageSeverity");
/**
 * Alert message for user. The purpose of this structure is to pass some message from backend to an user.
 * Specification of alerts: https://docs.google.com/spreadsheets/d/19VKiEkXXfGuBQUU1s-HmJ6mZUz0GXqwhaH3v-oAbAIg/edit#gid=0
 *
 * @author JGr
 * @author Radek Beran
 */


var UserMessage =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(UserMessage, _DomainObject_1$Domai);

  /**
   * @param severity A severity which can be used by frontend to select a correct presentation of the message.
   * @param code A key in message bundle.
   * @param args Arguments of the message. A value is always string and the frontend is responsible
   * @param flags message flags
   * to transform it to something else if needed.
   */
  function UserMessage(severity, code, args, flags) {
    var _this;

    _classCallCheck(this, UserMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserMessage).call(this));
    _this.severity = severity;
    _this.code = code;
    _this.args = args;
    _this.flags = flags;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to user message type.
   */


  _createClass(UserMessage, [{
    key: "equals",

    /**
     * @inheritDoc
     */
    value: function equals(other) {
      if (other instanceof UserMessage) {
        return this.severity === other.severity && this.code === other.code && this.args.equals(other.args);
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.code);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.severity.toString(), " ").concat(this.code.toString());
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new UserMessage(mat.severity, mat.code, mat.args, mat.flags);
    }
  }]);

  return UserMessage;
}(DomainObject_1.DomainObject);

exports.UserMessage = UserMessage;
UserMessage.EMPTY_LIST = immutable_1.List();
UserMessage.EMPTY_ARGS = immutable_1.List();

UserMessage.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(UserMessage.name);
  return {
    severity: builder.senum('severity', UserMessageSeverity_1.UserMessageSeverity, 'seq'),
    code: builder.senum('code', UserMessageCode_1.UserMessageCode, 'seq'),
    args: builder.listOf(builder.str('args')),
    flags: builder.flags('flags', UserMessageFlag_1.UserMessageFlag)
  };
}();